/*
 * Проверяет, является ли узел `ancestor` тем же самым элементом, что и `node`,
 * или одним из его родительских элементов.
 *
 * @param ancestor - Узел, с которым нужно сравнивать.
 * @param node - Целевая нода для проверки.
 * @returns {boolean} - Возвращает true, если `node` равен `ancestor` или одному из его родительских элементов.
 */
export function isNodeOrAncestor(ancestor: Node | null, node: Node | null): boolean {
    if (!node || !ancestor) {
        return false; // Если любой из узлов null, возвращаем false
    }

    let currentNode: Node | null = node;

    while (currentNode) {
        if (currentNode === ancestor) {
            return true;
        }

        currentNode = currentNode.parentNode;
    }

    return false;
}
